module.exports = __webpack_public_path__ + "img/Flag_of_Qatar.10723b60.svg";